/**
 * Environment configuration utility
 *
 * This file provides a centralized way to access environment variables
 * with proper typing and default values.
 */

interface EnvConfig {
  API_BASE_URL: string;
  IS_PROD: boolean;
  ENABLE_AUTH_GUARD: boolean;
  ENABLE_SOCKET: boolean;
}

// Env vars are always strings (e.g. "false"), and a non-empty string is truthy.
// Parse them explicitly so VITE_PROD=false / VITE_ENABLE_SOCKET=false behave as booleans.
const toBool = (v: unknown): boolean => v === true || v === 'true';

const isProd = toBool(import.meta.env.VITE_PROD);

const env: EnvConfig = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? '',
  IS_PROD: isProd,
  ENABLE_AUTH_GUARD: false,
  // Socket is on in prod, or whenever VITE_ENABLE_SOCKET=true is set (matches socketService hint).
  ENABLE_SOCKET: isProd || toBool(import.meta.env.VITE_ENABLE_SOCKET),
};

export default env;
